import { render, staticRenderFns } from "./DatasetGroupSelectorTree.vue?vue&type=template&id=2e22c97d&scoped=true&"
import script from "./DatasetGroupSelectorTree.vue?vue&type=script&lang=js&"
export * from "./DatasetGroupSelectorTree.vue?vue&type=script&lang=js&"
import style0 from "./DatasetGroupSelectorTree.vue?vue&type=style&index=0&id=2e22c97d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22c97d",
  null
  
)

export default component.exports